/** 图标类别 */
export enum PicsType {
  VIP,
  COMMON,
}

/** tab类别 */
export enum AnalysisTabEnums {
  /** 搜索行业分析 */
  TRADE = "trade",
  /** 搜索词分析 */
  WORD = "word",
}

export const analyseTypeLabel = {
  [AnalysisTabEnums.TRADE]: "搜索行业分析",
  [AnalysisTabEnums.WORD]: "搜索词分析",
};

export const analyseTypeTabs = [
  {
    value: AnalysisTabEnums.TRADE,
    label: analyseTypeLabel[AnalysisTabEnums.TRADE],
  },
  {
    value: AnalysisTabEnums.WORD,
    label: analyseTypeLabel[AnalysisTabEnums.WORD],
  },
];

/** 指数 */
export enum Idx {
  SEARCH = "search",
  VISITOR = "visitor",
  CLICK = "click",
  COMPETITION = "competition",
}

export const idxLabel = {
  [Idx.SEARCH]: "搜索指数",
  [Idx.VISITOR]: "访客指数",
  [Idx.CLICK]: "点击指数",
  [Idx.COMPETITION]: "竞争指数",
};

export const idxColor = {
  [Idx.SEARCH]: "#4C67FF",
  [Idx.VISITOR]: "#3DCC93",
  [Idx.CLICK]: "#EB679D",
  [Idx.COMPETITION]: "#F6C514",
};

export const IDX_KEY_MAP = {
  [Idx.SEARCH]: "searchIdx",
  [Idx.VISITOR]: "visitorIdx",
  [Idx.CLICK]: "clickIdx",
  [Idx.COMPETITION]: "competitionIdx",
};

export const idxCheckboxOptions = [
  { value: Idx.SEARCH, label: idxLabel[Idx.SEARCH] },
  {
    value: Idx.VISITOR,
    label: idxLabel[Idx.VISITOR],
  },
  { value: Idx.CLICK, label: idxLabel[Idx.CLICK] },
  {
    value: Idx.COMPETITION,
    label: idxLabel[Idx.COMPETITION],
  },
];

export const DEFAULT_ZHI_BIAO = [Idx.SEARCH];

export const QUESTION_NOTICE_NAME = "指标定义说明：";

export const QUESTION_NOTICES = [
  "1.搜索指数：商家所选类目下，按照搜索次数等聚合的指数，数据信息并非实时更新，有一定滞后性，仅供参考",
  "2.访客指数：商家所选类目下，按照搜索用户数等聚合的指数，数据信息并非实时更新，有一定滞后性，仅供参考",
  "3.点击指数：商家所选类目下，按照搜索点击数等聚合的指数，数据信息并非实时更新，有一定滞后性，仅供参考",
  "4.竞争指数：商家所选类目下，按照类目竞争情况等聚合的指数，数据信息并非实时更新，有一定滞后性，仅供参考",
];
